import { AFFILIATES } from '../../constants/appConstant';

import { goibiboTheme } from './giTheme';
import { indigoTheme } from './igoTheme';
import { aixTheme } from './aixTheme';
import { defaultTheme } from './mmtTheme';

const getComputedThemeObject = (baseTheme = {}, theme = {}) => {
  const computedTheme = { ...theme };
  Object.keys(baseTheme).forEach(key => {
    if (theme[key]) {
      if (
        typeof theme[key] === 'object' &&
        !Array.isArray(theme[key]) &&
        typeof baseTheme[key] === 'object' &&
        !Array.isArray(baseTheme[key])
      ) {
        computedTheme[key] = getComputedThemeObject(baseTheme[key], theme[key]);
      } else {
        computedTheme[key] = theme[key];
      }
    } else {
      computedTheme[key] = baseTheme[key];
    }
  });

  return computedTheme;
};

export const getTheme = (affiliate = AFFILIATES.MMT) => {
  let theme = defaultTheme;
  if (affiliate === AFFILIATES.GOIBIBO) {
    theme = goibiboTheme;
  } else if (affiliate === AFFILIATES.INDIGO) {
    theme = indigoTheme;
  } else if (affiliate === AFFILIATES.AIX) {
    theme = aixTheme;
  } else {
    return defaultTheme;
  }

  return getComputedThemeObject(defaultTheme, theme);
};

export { defaultTheme };
